import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DTypeStatus } from '@grupo-constant/next-dtype/types';
import { catchError, map, Observable, of } from 'rxjs';
import { adminUri, developerUri, UserNodePrivileges } from '../endpoints/endpoints.types';
import { Net2BeepleOu, OU_URI, RetrieveNet2BeepleOuReply, UpdateNet2BeepleOuReply } from './ou.types';
import { DTypeService } from '../../../core/dtype/dtype.service';
import { HttpService } from '../../../core/http/http.service';
import { Net2BeepleMethodsEnum } from '../../../core/enums/net2beeple-methods.enum';
import { USER_URI } from '../../../core/user/user.types';


export const ouResolver: ResolveFn<any> = () => {
    return inject(OUService).retrieveOu();
}

@Injectable({
    providedIn: 'root'
})
export class OUService {

    private _ou: WritableSignal<Net2BeepleOu> = signal(undefined);
    readonly ou = this._ou.asReadonly();
    private _role: WritableSignal<UserNodePrivileges> = signal(undefined);
    readonly role = this._role.asReadonly();

    private dtypeService = inject(DTypeService);
    private http = inject(HttpService);

    setRole(role: UserNodePrivileges | undefined) {
        this._role.set(role);
    }

    getOuForm() {
        return this.dtypeService.getDtypeFormByUri({ uri: OU_URI, status: DTypeStatus.DESIGN, bindableOptions: true }, this._ou(), { readonly: false, isUpdate: true});
    }

    updateOu(ou: Net2BeepleOu) {
        return this.http.post<UpdateNet2BeepleOuReply>(Net2BeepleMethodsEnum.updateNet2BeepleOu, { net2BeepleOu: ou });
    }

    retrieveOu(): Observable<Net2BeepleOu> {
        return this.http.post<RetrieveNet2BeepleOuReply>(Net2BeepleMethodsEnum.retrieveNet2BeepleOu, { ou: '01' }).pipe(
            map((reply) => {
                reply.net2BeepleOu.developer = reply.net2BeepleOu[developerUri]?.map(u => {
                    // u.displayName = u.sAMAccountName;
                    u = { ...u, ...reply.partaker[USER_URI]?.[u.userId] };
                    return u;
                }) ?? [];
                reply.net2BeepleOu.admin = reply.net2BeepleOu[adminUri]?.map(u => {
                    // u.displayName = u.sAMAccountName;
                    u = { ...u, ...reply.partaker[USER_URI]?.[u.userId] };
                    return u;
                }) ?? [];
                this._ou.set(reply.net2BeepleOu);
                this._role.set(reply.net2BeepleOu?.role);
                return reply.net2BeepleOu;
            }),
            catchError(error => {
                console.log(error);
                return of({});
            })
        );
    }

    updateMiniBus() {
        return this.http.post(Net2BeepleMethodsEnum.updateMiniBus, {});
    }

}
